module.exports = __webpack_public_path__ + "img/profil.f8d19b15.png";